export async function getAllPayments(thisCompanies): Promise<any[]> {
    const companies = await thisCompanies.toArray();
    return companies
        .map(company => company.payments || [])
        .reduce((acc, payments) => acc.concat(payments), []);
}
